import { takeLatest, call, put, select } from "redux-saga/effects";
import { createAction } from "redux-actions";
import dayjs from "dayjs";
import { getCommonApiParams } from "../../../../utils/redux-helpers.js";
import { api } from "../api.js";
import { API_DATE_FORMAT } from "../../../../app_constants.js";

export const SET_UPDATES_LOADING = "saga/activePackages/SET_UPDATES_LOADING";
export const SET_FILTERS_DIRTY = "saga/activePackages/SET_FILTERS_DIRTY";
export const SET_MODULE_VIEW = "saga/activePackages/SET_MODULE_VIEW";
export const SET_LOADING = "saga/activePackages/SET_LOADING";
export const SET_DATES = "saga/activePackages/SET_DATES";

export const FETCH_CURRENT_USER_SUCCESS = "saga/activePackages/FETCH_CURRENT_USER_SUCCESS";
export const DATA_SUCCESS = "saga/activePackages/DATA_SUCCESS";
export const FETCH_CURRENT_USER = "saga/activePackages/FETCH_CURRENT_USER";

export const UPDATE_CUSTOM_RANGE = "saga/activePackages/UPDATE_CUSTOM_RANGE";
export const UPDATE_MODULE_VIEW = "saga/activePackages/UPDATE_MODULE_VIEW";
export const UPDATE_FILTER = "saga/activePackages/UPDATE_FILTER";
export const UPDATE_DATES = "saga/activePackages/UPDATE_DATES";
export const UPDATE_DATA = "saga/activePackages/UPDATE_DATA";

export const RESET_SELECTED_FILTERS = "saga/activePackages/RESET_SELECTED_FILTERS";
export const RESET_DATA = "saga/activePackages/RESET_DATA";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  updateCustomRange: createAction(UPDATE_CUSTOM_RANGE),
  updateModuleView: createAction(UPDATE_MODULE_VIEW),
  updateFilter: createAction(UPDATE_FILTER),
  updateDates: createAction(UPDATE_DATES),
  updateData: createAction(UPDATE_DATA),
  resetData: createAction(RESET_DATA)
};

export default function* watchActivePackages() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_MODULE_VIEW, updateView);
  yield takeLatest(UPDATE_DATA, updateDataByView);
  yield takeLatest(RESET_DATA, resetData);
}

function* getCurrentUserData({ payload }) {
  try {
    yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload });
    yield put({ type: SET_LOADING, payload: true });

    yield setDates();
    yield requestByView();

    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateView({ payload }) {
  yield put({ type: SET_MODULE_VIEW, payload: payload });

  yield resetData();
}

function* fetchTrendData() {
  try {
    yield put({ type: SET_UPDATES_LOADING, payload: true });

    const params = yield getApiParams();
    const { data } = yield call(api.trend.getData, params);

    yield put({
      type: DATA_SUCCESS,
      payload: data
    });

    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchDetailsData() {
  try {
    yield put({ type: SET_UPDATES_LOADING, payload: true });

    const params = yield getApiParams();
    const { data } = yield call(api.details.getData, params);

    yield put({
      type: DATA_SUCCESS,
      payload: data
    });
    yield put({ type: SET_UPDATES_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

export function* requestByView() {
  const moduleView = yield select((state) => state.activePackages.selectedFilters.moduleView.id);

  if (moduleView === "details") {
    yield fetchDetailsData();
  } else {
    yield fetchTrendData();
  }
}

export function* updateDataByView() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield requestByView();
}

function* setDates() {
  const endDate = yield select((state) => state.activePackages.currentUser.calendarEndDate);
  const startDate = dayjs(endDate).subtract(11, "month").startOf("month").format(API_DATE_FORMAT);

  yield put({
    type: SET_DATES,
    payload: {
      startDate,
      endDate
    }
  });
}

function* resetData() {
  yield put({ type: SET_FILTERS_DIRTY, payload: false });
  yield put({ type: SET_LOADING, payload: true });

  yield put({ type: RESET_SELECTED_FILTERS });
  yield setDates();

  try {
    yield requestByView();
    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getApiParams() {
  let commonParams = yield getCommonApiParams("commonReducer", "commonProps");

  let {
    requestDates: { startDate, endDate },
    moduleView,
    date
  } = yield select((state) => state.activePackages.selectedFilters);

  const paramsByView =
    moduleView.id === "details"
      ? {
          date
        }
      : { start_date: startDate, end_date: endDate };

  return {
    ...commonParams,
    ...paramsByView
  };
}
